// Sdílená datumová pole s pevným formátem DD.MM.YYYY (resp. DD.MM.YYYY HH:MM, 24 h) a českým
// kalendářem (týden od pondělí). Hodnota navenek zůstává řetězec jako u nativních inputů:
//   DateInput:     'YYYY-MM-DD'        (složené z místních hodnot, bez posunu přes UTC)
//   DateTimeInput: 'YYYY-MM-DDTHH:mm'  (místní čas; na ISO s pásmem ho převádí zLocalInput)
import DatePicker, { registerLocale } from 'react-datepicker';
import { cs } from 'date-fns/locale/cs';
import 'react-datepicker/dist/react-datepicker.css';
import { inputStyle, useSirka } from '../ui';

registerLocale('cs', cs);

const pad = n => String(n).padStart(2, '0');

function naDate(v) {
  if (!v) return null;
  const [d, cas = '00:00'] = v.split('T');
  const [r, m, den] = d.split('-').map(Number);
  const [h, min] = cas.split(':').map(Number);
  const out = new Date(r, m - 1, den, h || 0, min || 0);
  return isNaN(out) ? null : out;
}

function zDate(d, sCasem) {
  if (!d) return '';
  const datum = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  return sCasem ? `${datum}T${pad(d.getHours())}:${pad(d.getMinutes())}` : datum;
}

function Pole({ value, onChange, sCasem, style, ...rest }) {
  const mobil = useSirka() < 640;
  return (
    <DatePicker
      selected={naDate(value)}
      onChange={d => onChange(zDate(d, sCasem))}
      locale="cs"
      dateFormat={sCasem ? 'dd.MM.yyyy HH:mm' : 'dd.MM.yyyy'}
      placeholderText={sCasem ? 'DD.MM.RRRR HH:MM' : 'DD.MM.RRRR'}
      showTimeSelect={sCasem}
      timeFormat="HH:mm"
      timeIntervals={5}
      timeCaption="Čas"
      showPopperArrow={false}
      withPortal={mobil}
      calendarStartDay={1}
      autoComplete="off"
      customInput={<input style={{ ...inputStyle, ...style }} />}
      wrapperClassName="entsol-datepicker"
      {...rest}
    />
  );
}

export const DateInput = props => <Pole {...props} sCasem={false} />;
export const DateTimeInput = props => <Pole {...props} sCasem />;
